import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing'; 

const _baseUrl: string = Licensing.PRODUCT_ROUTES.get(Licensing.Products.OneSite.HEALTH);

export const ENDPOINT_HEALTH_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: Licensing.Products.OneSite.HEALTH,
	route: _baseUrl,
	sidenav: {
		productName: Licensing.Products.OneSite.HEALTH,
		sections: [{
			items: [
				{
					display: 'Home',
					route: '/endpoint-health',
					icon: 'faHomeOutline'
				},
				{
					display: 'Health Policies',
					route: `${_baseUrl}/policies`,
					icon: 'faClipboardOutline',
					linkedRoutes: [`${_baseUrl}/dashboards/policies/:PolicyId`],
				},
				{
					display: 'Health Checks',
					route: `${_baseUrl}/checks`,
					icon: 'faFileCheckOutline',
					linkedRoutes: [`${_baseUrl}/dashboards/checks/:CheckId`],
				}
			]
		}]
	}
};
